import { lazyLoad } from 'utils/loadable';

export const FrontendLayout = lazyLoad(
  () => import('./index'),
  module => module.FrontendLayout,
);
